import { useField } from 'formik';

import { Form, Label } from 'semantic-ui-react';

interface Props {
  placeholder: string;
  name: string;
  label?: string;
  type?: string;
  disabled?: boolean;
  value?: string | number;
  onChange?: any;
  onBlur?: any;
  onMouseOut?: any;
  onMouseOver?: any;
  mandatory?: boolean;
  style?: any;
  touched?: boolean;
}

export default function MyTextInput(props: Props) {
  const [field, meta] = useField(props.name);
  return (
    <Form.Field error={meta.touched && !!meta.error}>
      {props.mandatory ? (
        <>
          <label style={{ display: 'inline-block' }}>{props.label}</label>
          <span style={{ color: '#9f3a38' }}>*</span>
        </>
      ) : (
        <label>{props.label}</label>
      )}
      <input
        style={{ backgroundColor: 'white' }}
        {...field}
        {...props}
        autoComplete="new-password"
        maxLength={151}
      />
      {(meta.touched || props.touched) && meta.error ? (
        <Label basic color="red">
          {meta.error}
        </Label>
      ) : null}
    </Form.Field>
  );
}
